import { ReactNode } from 'react';
import alertIcon from '@assets/alert.svg';
import styled from '@emotion/styled';

const Container = styled('div')`
  background: linear-gradient(#00132b, #013d58);
  min-height: 100vh;
  overflow: hidden;
`;

const Inner = styled('div')`
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  color: white;
`;

const Title = styled('h3')`
  font-size: 20px;
  padding-top: 34px;
  font-weight: 600;
  text-align: left;
  width: 100%;
`;

const Body = styled('div')`
  text-align: left;
  width: 100%;
`;

export const SandboxMessageScreen = ({
  icon,
  title,
  body,
  children,
}: {
  icon?: string;
  title?: string;
  body?: string;
  children?: ReactNode;
}) => (
  <Container data-testid="SandboxMessageScreen">
    <Inner>
      <img src={icon ?? alertIcon} width="180" alt="" role="presentation" />
      {title && <Title>{title}</Title>}
      <Body>{body}</Body>
      {children}
    </Inner>
  </Container>
);
